import { FileList } from "core/hookForm/components/droparea";
import { FileItem } from "types/form";

type Props = {
    name: string;
    disabled?: boolean;
    displayWhenEmpty?: boolean;
    onDeleteFile?: (file: FileItem) => Promise<void>;
};

export default function HookFormFileList({ name, disabled, displayWhenEmpty, onDeleteFile }: Props) {
    return <FileList name={name} disabled={disabled} displayWhenEmpty={displayWhenEmpty} onDeleteFile={onDeleteFile} />;
}
